import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

export const AboutPage = () => {
  return (
    <div className="min-h-screen py-20 px-4 sm:px-6 lg:px-8 bg-[#0B1120] text-white">
      <Helmet>
        <title>About Us | Nitro Logs</title>
        <meta name="robots" content="index, follow" />
      </Helmet>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-5xl mx-auto"
      >
        <div className="mb-10 text-center">
          <p className="text-sm uppercase tracking-widest text-blue-400">About Nitro Logs</p>
          <h1 className="text-4xl lg:text-5xl font-bold mt-4">We Build Social Growth Tools with Trust</h1>
          <p className="mt-4 text-gray-400 max-w-3xl mx-auto">
            Nitro Logs helps creators, agencies, and businesses buy verified social media accounts, boosting services, and virtual numbers with secure payments.
          </p>
        </div>

        <div className="grid gap-10 lg:grid-cols-2 text-gray-300">
          <div className="space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Our Mission</h2>
              <p className="leading-relaxed">
                We want to make social media growth safe, fast, and reliable. Our platform connects buyers with verified services while protecting transactions with secure payment tools.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">What We Offer</h2>
              <ul className="list-disc list-inside space-y-2 leading-relaxed">
                <li>Verified social media accounts for major platforms.</li>
                <li>Organic boosting and growth services.</li>
                <li>Virtual numbers for SMS-ready verification.</li>
                <li>Secure deposits through integrated payment gateways.</li>
              </ul>
            </section>
          </div>

          <div className="space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Why Choose Us</h2>
              <p className="leading-relaxed">
                Nitro Logs is built for reliability and convenience. We combine trusted services with a strong focus on customer support and fast delivery.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Contact</h2>
              <p className="leading-relaxed">
                Have questions? Reach out at nitrologs9@gmail.com or visit our support page for direct help and account assistance.
              </p>
            </section>
          </div>
        </div>
      </motion.div>
    </div>
  );
};
